import ActionTypes from '../constants/ActionTypes';
import standardAction from '../../../utilities/standard-action';

export default function clearRecentSearches() {
  return standardAction(ActionTypes.CLEAR_RECENT_SEARCHES);
}
